export const experienceData = [{
    title: "SDE Intern",
    date: "Jan - June 23'",
    company: "Amazon",
    description: `Worked under the Consumer Payments - International Expansion Tech team and implemented DirectedId, 
    a customer unique identifier, in Stripe based payment methods like P24, iDEAL, SepaDD and Bancontact that are 
    used in several European countries like NL, PL and DE.`,
}, {
    title: "Summer Analyst",
    date: "July - Aug 22'",
    company: "Goldman Sachs",
    description: `Worked under the Asset Management Division - Sales and Marketing CRM tools (Client Relationship Management) 
    Tech team and migrated the UI of internal tools used by the Sales team.`,
}, {
    title: "Engage 21' Mentee",
    date: "June - July 21'",
    company: 'Micorsoft',
    description: `Shortlisted for the Engage Mentorship program 21' and built a video conferencing web based 
    application called Microsoft Teams Clone having multiple features like screen-sharing, white board scribbling and 
    chatting along with emojis. Selected for the technical interviews but was unable to make to the SWE intership.`,
}, {
    title: "Open Source Contributor",
    date: "March - May 21'",
    company: "GirlScript Summer of Code 21'",
    description: `Contributed to open source projects and created 30 around issues in various repositories. My 26 pull
    requests got merged. My major contributions were in frontend styling, java script basic projects and few algorithms in Java language.`,
}, {
    title: "DSA - Java Mentee",
    date: "Oct 19' - March 21'",
    company: 'Girl Code It',
    description: `Girl Code It is a initiative to encourage freshers to kick start their journey in coding and development.
    I was a part of the DSA track in Java language, and solved 400+ questions on various platforms.`,
}];